import { FC } from "react";
import { useTranslation } from "react-i18next";
import SharedGridPage from "./SharedGridPage";
import EditAiAgent from "src/components/aiAgents/EditAiAgent";

const ManageAiAgent: FC = () => {
    const { t } = useTranslation();

    return (
        <SharedGridPage
            title={t('AiAgentList.EditAiAgent')}
            subComponent={<EditAiAgent />}
        />
    );
};

export default ManageAiAgent;